import { Button } from "antd";
import crrButtonStyles from "./CrrButton.module.scss";

class CrrButtonProps {
  /**
   * @type {!string}
   */
  children;

  /**
   * @type {?string}
   */
  className;

  /**
   * @type {?string}
   */
  type;

  /**
   * @type {?boolean}
   */
  loading;

  /**
   * @callback onClickCallback
   */
  /**
   * @type {!onClickCallback}
   */
  onClick;
}

/**
 *
 * @param {CrrButtonProps} props
 */
export default function CrrButton(props) {
  return (
    <Button
      className={`
                cb-btn
                ${props.className || ""} 
                ${crrButtonStyles.btn}
            `}
      type={props.type || "primary"}
      loading={props.loading}
      onClick={props.onClick}
      htmlType={props.htmlType}
      ghost={props.ghost}
      title={props?.title}
    >
      {props.children}
    </Button>
  );
}
